import type { RegulationUiState } from './regulationUi.model';

export function isKidOpen(state: RegulationUiState, tabId: string): boolean {
  return (state[tabId] && state[tabId].kidIsOpen) || false;
}

export function isMifidOpen(state: RegulationUiState, tabId: string): boolean {
  return (state[tabId] && state[tabId].mifidIsOpen) || false;
}

export function isTargetOpen(state: RegulationUiState, tabId: string): boolean {
  return (state[tabId] && state[tabId].targetIsOpen) || false;
}

export function isTheoreticalValueOpen(state: RegulationUiState, tabId: string): boolean {
  return (state[tabId] && state[tabId].theoreticalValueIsOpen) || false;
}
